"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var staticDisclaimerStyles = makeStyles_1.default(function () { return ({
    disclaimer: {
        display: 'inline-block',
        position: 'relative',
        margin: '20px 20px 40px',
        textAlign: 'justify',
    },
}); }, { name: 'GqlCheckout_StaticDisclaimer' });
exports.default = staticDisclaimerStyles;
